import * as React from 'react';
import './App.css';
import { Link } from 'react-router-dom';
import { passwordMessage } from './validate';
import * as Util from './util';
import { SyntheticEvent } from 'react';
import { commit } from './commit';
import { footer } from './widgets/Footer';

import * as ClientHome from './client/Home';

export interface LoginState {
    focussed: string;
    unknown: boolean;
    email: string;
    password: string;
    resetDone: boolean;
}

export interface LoginProps {
    reset?: boolean;
}

export const frame = (contents: object) => {
    return (
        <div className="App" style={{height: '100%', backgroundAttachment: 'fixed', overflow: 'auto'}}>
            <div className="container" style={{height: '100%'}}>
                <br /> <br />
                <div className="row">
                    <div className="col-sm-8 offset-sm-2" style={{backgroundColor: 'white'}}>
                        <h1 className="pt-3 text-center">Axceller @ KorumLegal</h1>
                        {contents}
                    </div>
                </div>
                {footer('')}
            </div>
        </div>
    );
};

const loginFrame = (contents: object) => {
    return (
        <div className="row no-gutters min-h-fullscreen bg-white">
            <div className="col-md-6 col-lg-5 col-xl-4 align-self-center" style={{margin: 'auto'}}>
                {contents}
            </div>
        </div>
    );
};

export const toBeImplemented = () => loginFrame(<h5>To be implemented</h5>);

export const registerPanel = () => loginFrame(
    <div className="px-80 py-30">
        <h3>Register</h3>
        <div className="card">
            <div className="card-body text-center">
                <h5>Customer</h5>
                <a href="/#/registerClient" className="btn btn-outline btn-secondary">I would like to register as a customer</a>
            </div>
        </div>
        <div className="card">
            <div className="card-body text-center">
                <h5>Consultant</h5>
                <a href="/#/registerConsultant" className="btn btn-outline btn-secondary">I would like to register as a consultant</a>
            </div>
        </div>
    </div>
);

interface Focussable {
    focussed: string;
}

export class LoginForm<A, B extends Focussable> extends React.Component<A, B> {
    assocState(stateKey: string, v: any) {
        const newState = {...(this.state as object), [stateKey]: v} as B;
        this.setState(newState);
    }
    focus(focussed: string) {
        this.setState({...(this.state as object), focussed});
    }
    input(type: string, label: string, stateKey: string, required: boolean) {
        return (
            <div className={this.state.focussed === stateKey || this.state[stateKey] ? 'form-group do-float' : 'form-group'}>
                <input
                    type={type}
                    className="form-control"
                    required={required}
                    value={this.state[stateKey]}
                    onChange={(e: SyntheticEvent<any>) => this.assocState(stateKey, e.currentTarget.value)}
                    id={stateKey}
                    onFocus={(e) => this.focus(stateKey)}
                    onBlur={(e) => this.focus('')}
                />
                <label>{label}</label>
            </div>
        );
    }
    email(label: string, stateKey: string) {
        return this.input('email', label, stateKey, true);
    }
    text(label: string, stateKey: string) {
        return this.input('text', label, stateKey, true);
    }
    password(label: string, stateKey: string) {
        return this.input('password', label, stateKey, true);
    }
}

export class Login extends LoginForm<LoginProps, LoginState> {
    constructor(props: LoginProps) {
        super(props);
        this.state = {unknown: false, email: '', password: '', resetDone: false, focussed: ''};
    }
    async submit() {
        const result = await ClientHome.login(this.state);
        if (result.status === 403) {
            this.setState({...this.state, unknown: true});
        } else if (result.status === 200) {
            const redirect = location.href.split('redirect=')[1];
            if (redirect) {
                location.href = redirect;
                if (!redirect.startsWith(Util.backend as string)) {
                    setTimeout(() => location.reload(), 100);
                }
            } else {
                location.reload();
            }
        }

    }
    alertDanger(show: boolean, msg: string) {
        if (show) {
            return (
                <div className="alert alert-danger">
                    {msg}
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        const version = () => alert(`Commit: ${commit}`);
        return loginFrame(
            <div className="px-80 py-30">
                <div className="float-right">
                    <img src="Korum_Final_72.png" alt="..." width="200px" />
                </div>
                <div className="clearfix" />
                <h4>Axceller @ KorumLegal</h4>
                {location.host.startsWith('st') ? <h1 style={{color: 'red'}}>Staging Site!!!</h1> : null}
                <br />

                <form
                    className="form-type-material"
                    onSubmit={Util.submit(this)}
                >
                    {this.email('Email', 'email')}
                    {this.password('Password', 'password')}
                    {this.alertDanger(this.state.unknown, 'Unknown email or password')}

                    <div className="form-group flexbox">
                        <a className="text-muted hover-primary fs-13" href="#/login/reset">Forgot password?</a>
                    </div>

                    <div className="form-group">
                        <button className="btn btn-bold btn-block btn-primary" type="submit">Login</button>
                    </div>
                </form>
                {Util.isProd ? null : (
                    <div className="form-group">
                        <button className="btn btn-bold btn-block btn-primary" onClick={version}>Version (does not appear in production)</button>
                    </div>)}

                <hr className="w-30px" />

            </div>
        );
    }
}

interface ResetState {
    email: string;
    done: boolean;
    focussed: string;
}

export class Reset extends LoginForm<object, ResetState> {
    constructor(props: object) {
        super(props);
        this.state = {email: '', done: false, focussed: ''};
    }
    async submit() {
        const result = await ClientHome.resetPassword(this.state);
        const done = result.status === 200;
        this.setState({...this.state, done});
    }
    render() {
        return loginFrame(
            this.state.done ? (
                <div className="px-80 py-30">
                    <h4>Please check your email</h4>
                </div>
                ) : (
                <div className="px-80 py-30">
                    <h4>Password recovery</h4>
                    <p><small>We'll send you instructions in email</small></p>
                    <br />

                    <form className="form-type-material" onSubmit={Util.submit(this)}>
                        {this.email('Email', 'email')}
                        <br />
                        <button className="btn btn-bold btn-block btn-primary" type="submit">Reset</button>
                    </form>
                </div>
            )
        );
    }
}

interface Reset2State {
    errors: object;
    name: string;
    password1: string;
    password2: string;
    token: string;
    finished: boolean;
    validToken: boolean;
    focussed: string;
}

interface ResetProps {
    match: {params: {token: string}};
}

interface Params {
    redirect?: string;
    name?: string;
}

export class Reset2 extends LoginForm<ResetProps, Reset2State> {
    params: Params = Util.queryString();
    constructor(props: ResetProps) {
        super(props);
        this.state = {
            name: '',
            password1: '',
            password2: '',
            errors: {},
            token: props.match.params.token,
            finished: false,
            validToken: false,
            focussed: '',
        };
    }
    async submit() {
        const result = await ClientHome.resetPassword2(this.state);
        if (result.status === 200) {
            const {redirect} = this.params;
            if (redirect) {
                location.href = redirect;
                setTimeout(() => location.reload(), 100);
            } else {
                location.reload();
            }
        } else {
            this.setState({...this.state, finished: true, validToken: false});
        }
    }
    assocState(k: string, v: any) {
        switch (k) {
            case 'password1':
                Util.customValidity(k, v.length < 5 ? passwordMessage : '');
                break;
            case 'password2':
                Util.customValidity(k, v === this.state.password1 ? '' : 'Passwords must match');
                break;
            default:
        }
        super.assocState(k, v);
    }

    render() {
        return loginFrame(
            !this.state.finished ?
                (
                    <div className="px-80 py-30">
                        <div className="float-right">
                            <img src="Korum_Final_72.png" alt="..." width="200px" />
                        </div>
                        <div className="clearfix" />
                        <h4>Axceller @ KorumLegal</h4>
                        {location.host.startsWith('st') ? <h1 style={{color: 'red'}}>Staging Site!!!</h1> : null}
                        <br />
                        <form onSubmit={Util.submit(this)} className="form-type-material">
                            <h4>Set Password</h4>
                            {this.params.name ? this.text('Name', 'name') : null}
                            {this.password('Password', 'password1')}
                            {this.password('Repeat Password', 'password2')}
                            <input className="btn btn-bold btn-block btn-primary" type="submit" value="Submit" />
                        </form>
                    </div>
                ) : (
                    this.state.validToken ?
                        <div className="b-3">Password reset.  Please <Link to="/login">Login</Link>.</div>
                        : <div className="b-3">Invalid Token.  Please <Link to="/login/reset">Reset Again</Link>.</div>
                )
        );
    }
}



// WEBPACK FOOTER //
// ./src/Login.tsx